import React, { useState } from 'react';
import StyledButton from 'shared-resources/components/src/StyledButton';

const CopyButton = ({ copyText, ...rest }) => {
  const [buttonColor, setButtonColor] = useState('bg-neutral-pri');
  const [textColor, setTextColor] = useState('text-neutral-pri');

  const [iconClass, setIconClass] = useState('fa fa-link')

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setIconClass('fa fa-check !text-inherit');
      setButtonColor('!bg-success hover:!bg-success');
      setTextColor('!text-success hover:!text-success');
      setTimeout(() => {
        setIconClass('fa fa-link !text-inherit');
        setButtonColor('!bg-neutral-pri');
        setTextColor('!text-neutral-pri');
      }, 1000);
    } catch (err) {
      setIconClass('fa fa-exclamation-triangle !text-error');
      setButtonColor('!bg-error hover:!bg-error');
      setTextColor('!text-error hover:!text-error');
      setTimeout(() => {
        setIconClass('fa fa-link !text-inherit');
        setButtonColor('!bg-neutral-pri');
        setTextColor('!text-neutral-pri');
      }, 1000);
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <StyledButton
      variant="text"
      rightIcon={<StyledButton.Icon faClass={iconClass} />}
      className={`${textColor} ${buttonColor}`}
      onClick={copyToClipboard}
      {...rest}
    />
  );
}

export default CopyButton;